export default {
	qingshururiqi: '請輸入日期!',
	zhuye: '主頁',
	jiudian: '機票',
	jipiao: '酒店',
	tongguo: '通過',
	zhongzhuanzai: '中轉在',
	shengdanshibailianxikefu: '生單失敗，請聯系客服！',
	zhongzhuanshijian: '中轉時間',
	kenengxuyaolvxingzhengjian: '可能需要旅行證件/簽證。',
	xinglitongguo: '行李通過',
	lvyoutaopiao: '旅遊套票',
	changlvkehao: '常旅客號',
	dumiyue: '渡蜜月',
	remenyouhui: '熱門優惠',
	chakanquanbu: '查看全部',
	tebietaopiao: '特別套票',
	lvyouxinxi: '旅遊信息',
	gouwuzhongxin: '購物中心',
	hangban: '航班',
	chengkeziliao: '乘客資料',
	fuyingchanpin: '輔營產品',
	queren: '確認',
	fukuan: '付款',
	chenggong: '成功',
	xuanzehangban: '選擇航班',
	piaojiaguize: '票價規則及備註',
	piaojiaguizes: '票價規則',
	feiwang: '飛往',
	fanhui: '返回',
	xiayibu: '下一步',
	gengduoxijie: '更多',
	yincangxijie: '隱藏',
	gengduo: '更多',
	gengshao: '更少',
	genggaihangban: '更改航班',
	jishangfuwu: '機上服務',
	boyinqi: '波音 777-300ER',
	yihaohangzhan: '1號航站樓',
	suoyoufeixingshijian: '所有飛行時間以24小時系統顯示。',
	xinguanfeiyan:
		'關於新冠肺炎在不同國家的最新發展，我們建議過境旅客在購買機票之前，先查看過境機場的最新機場政策以及最終目的地的入境限制。',
	zhongyingbuyizhi: '如果目的地和航空公司名稱的英文版和中文版之間有任何不一致之處，以英文版為准。',
	mingzitishi: '請以英文輸入您的正式首個名字(以護照記錄為準)<br>例如: 如您的全名為:<br>「Kwok Fu Hsing」，請輸入「Fu Hsing」 。 <br>Cheung Pak Chi Cecilia」，請輸入「Pak Chi Cecilia」 .<br>請勿輸入中文字。',
	xingshitishi: '請以英文輸入您的正式姓氏(以護照記錄為準):<br>例如:如您的全名為:<br>「Kwok Fu Hsing」，請輸入「Kwok」 。「Cheung Pak Chi Cecilia」，請輸入「Cheung」。<br>請勿輸入中文字。',
	huzhaohaomatishi: '此航空公司需要您提供護照號碼。',
	yudingchenggong: '預訂成功！',
	yudingshibai: '预定失败',
	yudingcankao: '預訂參攷：',
	nindeyudingyiqueren: '您的預訂已經確認。 確認電子郵件已發送至',
	nindeyudingyishibai: '你的預定已經失敗，請重新下單',
	ninyekyguanliwodeyuding: '您也可以在“我的預訂”中管理您的班機預訂。',
	piaojia: '票價',
	gongxianghangsi: '共亯航司',
	caozuotongguo: '執飛航司',
	fanhuitishixinxi: '如果您離開此頁面，訂單將不再保留，價格可能會更改。 你確定要離開嗎？',
	wuxingli: '無免費行李額',
	xingqi1: '週一',
	xingqi2: '週二',
	xingqi3: '週三',
	xingqi4: '週四',
	xingqi5: '週五',
	xingqi6: '週六',
	xingqi0: '週日',
	fareRules: {
		tuipiao: "退票",
		gaiqi: "改期",
		tuigaishuoming: "退改說明",
		qifeiqian: "起飛前",
		qifeihou: "起飛后",
		buketuipiao: "不可退票",
		buketuishui: "不可退稅",
		bukegaiqi: "不可改期",
		mianfeituipiao: "免費退票",
		mianfeituishui: "免費退稅",
		mianfeigaiqi: "免費改期",
		tuipiaofei: "退票費",
		tuishuifei: "退稅費",
		gaiqifei: "改期費",
		quanchengweishiyong: "全程未使用",
		quchengyishiyong: "去程已使用，退回程",
		chufahangban: "出發班機",
		huichenghangban: "回程班機"
	}
};
